import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureFlagService } from './services';
import { LaunchDarklyService } from './infrastructure/launch-darkly';
import { GetFeaturePipe } from './pipes/get-feature.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [GetFeaturePipe],
    exports: [GetFeaturePipe],
})
export class FeatureFlagsModule {
    static forRoot(): ModuleWithProviders<FeatureFlagsModule> {
        return {
            ngModule: FeatureFlagsModule,
            providers: [
                {
                    provide: FeatureFlagService,
                    useClass: LaunchDarklyService,
                },
            ],
        };
    }
}
